import React, { useRef } from 'react';
import useSetState from '../../../../hooks/useSetState';
import DatePicker from '../../../../components/FormElements/DatePicker/DatePicker';
import ENUMS from '../../../../enums/index';

const PurchasePackagesReportFilter = ({
  applyFilters,
  getPurchasePackagesList,
  resetForm,
}) => {
  let formRefrence = useRef();

  const [controls, setControls] = useSetState({
    fromDate: '',
    toDate: '',
    fullName: '',
  });

  const onChangeValue = (controleName, value) => {
    setControls({ [controleName]: value });
  };

  const onSubmit = event => {
    event.preventDefault();
    applyFilters(event, controls.fromDate, controls.toDate);
  };

  const onReset = () => {
    onChangeValue('fullName', '');
    onChangeValue('fromDate', ' ');
    onChangeValue('toDate', ' ');
    resetForm();
    getPurchasePackagesList();
  };

  return (
    <section className='bg-white my-2'>
      <form
        ref={formRefrence}
        onSubmit={event => onSubmit(event)}
        id='filterForm'
        className='card card my-4'
      >
        <header className='text-center card-header'>
          <h5 className='font-italic text-muted'>{locales('titles.filter')}</h5>
        </header>
        <main className='card-body'>
          <div className='d-flex row flex-lg-row flex-sm-column col-12 flex-md-row justify-content-between px-1 mx-1'>
            <div className='d-flex col-lg-4 col-md-12'>
              <label className='rsee-form-label col-lg-3'>
                {locales('fields.startDate')}
              </label>
              <div className='full-width'>
                <DatePicker
                  marge={true}
                  placeholder={locales('fields.startDate')}
                  name='fromDate'
                  onChange={val => onChangeValue('fromDate', val)}
                  value={controls.fromDate}
                  className='date-picker-input'
                />
              </div>
            </div>
            <div className='d-flex col-lg-4 col-sm-12'>
              <label className='rsee-form-label col-lg-3'>
                {locales('fields.endDate')}
              </label>
              <div className='full-width'>
                <DatePicker
                  marge={true}
                  placeholder={locales('fields.endDate')}
                  name='toDate'
                  onChange={val => onChangeValue('toDate', val)}
                  value={controls.toDate}
                  className='date-picker-input'
                />
              </div>
            </div>
            <div className='d-flex col-lg-4 col-sm-12'>
              <label className='rsee-form-label col-lg-3'>
                {locales('titles.FullName')}
              </label>
              <div className='full-width'>
                <input
                  onChange={event =>
                    onChangeValue('fullName', event.target.value)
                  }
                  value={controls.fullName || ''}
                  name='fullNamePart'
                  type='text'
                  className='form-control col-12'
                  placeholder={locales('tables.fullName')}
                  maxLength={ENUMS.MAX_LENGTH.fullName}
                />
              </div>
            </div>
          </div>

          <div className='col-12 d-flex justify-content-end p-0 my-3'>
            <button
              type='button'
              onClick={onReset}
              className='btn btn-danger w-5 mx-2'
            >
              {locales('fields.reset')}
            </button>
            <button type='submit' className='btn btn-success w-5 mx-2'>
              {locales('fields.applyFilters')}
            </button>
          </div>
        </main>
      </form>
    </section>
  );
};

export default PurchasePackagesReportFilter;
